import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {fetchSuburb, fetchMarketTrends} from '../../actions/index';
import {formatURL} from '../../lib/urlTools';
import styles from './SuburbWidget.scss';
import SuburbBlurb from './SuburbBlurb';

function SuburbWidget(props) {
  const suburbBlurb = useSelector(state => state.suburb);
  const dispatch = useDispatch();
  const {stateCode, suburb, postcode} = props;

  useEffect(() => {
    const defaultYear  = 10;
    const defaultPropertyType = 'Both';
    let thisBurb = suburb.replace(/\-/ig, '--');

    if (suburbBlurb.status === 'success' && (suburbBlurb.request?.postcode !== postcode)) {
      dispatch(fetchSuburb({suburb: thisBurb, postcode}));
      dispatch(fetchMarketTrends({suburb: thisBurb, postcode, stateCode, defaultYear, defaultPropertyType}));

    }
    else if (suburbBlurb?.status === 'loading') {
      dispatch(fetchSuburb({suburb: thisBurb, postcode}));
      dispatch(fetchMarketTrends({suburb: thisBurb, postcode, stateCode, defaultYear, defaultPropertyType}));
    }
  }, [suburbBlurb, suburb, postcode]);

  return (
    suburbBlurb.status === 'success' && suburbBlurb?.suburb_detail?.description && suburbBlurb?.request?.postcode === postcode ?
      <div className={'p-4 ' + styles.suburbWidget}>
        <h2>
          About {suburb} {postcode}
        </h2>
        <SuburbBlurb onPdp={true}/>
        <div className="mt-2"><Link to={formatURL(stateCode, suburb, postcode)}>{suburb} Profile Page<span className={styles.chevRight}></span></Link></div>
      </div>
      : null
  );
}

SuburbWidget.propTypes = {
  suburb: PropTypes.string.isRequired,
  postcode: PropTypes.string.isRequired,
  stateCode: PropTypes.string.isRequired,
};

export default SuburbWidget;
